import React from 'react'
import LegendWidget from '../../esri/legend/LegendWidget'
import SliderWidget from '../../esri/slider/Slider'
import LabelToggleWidget from '../label-toggle/LabelToggleWidget'
import { ThemeProvider } from "@mui/material/styles";
import { theme } from '../../../themes/MuiTheme'

const LayerListItemPanel = (props:any)=>{
    const {view,layer,showLabelToggle}=props
  return (
    <div>
      <ThemeProvider theme={theme}>
      <LegendWidget layers={[layer]} view={view} />
        <SliderWidget layer={layer} view={view}/>
        {showLabelToggle&&<LabelToggleWidget layer={layer} view={view}/>}
        </ThemeProvider>
    </div>
  )
  
}

export default LayerListItemPanel